export const urlApiServer = process.env.REACT_APP_API_URL 